
import UserSetting from '@/utils/userSetting'

export default () => ({
  isLoading: true,
  isLoadingMore: false,
  isFiltering: false,
  isFiltersApplied: true,
  isFavoriteLoading: false,
  loadingIsFailed: false,
  emptyFilteringResults: false,
  deleteMode: false,
  agencyPrice: false,
  viewType: UserSetting.getViewType(),
  errors: [],
  collection: [],
  collectionFilters: {
    locations: [],
    date: [],
  },
  form: {
    page: 1,
    perPage: 10,
    currency: 'RUB',
    priceSort: 'ascending'
  },
  filters: {
    locations: [],
    dateFrom: null,
    dateTo: null
  },
  dictionaries: {
    currency: []
  },
  filtersErrors: [],
  pagination: {
    page: 1,
    perPage: 10,
    lastPage: 1,
    total: 10
  }
})
